<div>
    <div id="chart-{{graph.code}}" style="display: block">
        <canvas baseChart
            [data]="values"
            [labels]="labels"
            [options]="option"
            chartType="pie"
            [colors]="colors">
        </canvas>
    </div>
</div>
